import { linkedin, Github, Mail, Whatsapp } from "../../assets";

export const socialMedia = [
  {
    id: "Conect on Linkedin",
    icon: linkedin,
    link: "https://www.linkedin.com/in/sastik-kumar-das-2b1633213/",
    target: "_blank",
  },
  {
    id: "Connect on Github",
    icon: Github,
    link: "https://github.com/Sastik",
    target: "_blank",
  },
  {
    id: "Mail Me",
    icon: Mail,
    link: "mailTo:sastikkumardas@gmail.com",
    target: "_blank",
  },
  {
    id: "Connect on Whatsapp",
    icon: Whatsapp,
    link: "https://wa.me/message/GDXNY4VEZAGWB1",
    target: "_blank",
  },
];
